import { render } from "./YearDetail.vue?vue&type=template&id=18dd51be"
import script from "./YearDetail.vue?vue&type=script&lang=ts"
export * from "./YearDetail.vue?vue&type=script&lang=ts"
script.render = render

export default script